import React, { useEffect, useState } from 'react';
import { Task, TaskResponse, TaskState } from 'gql/graphql';
import { CardLoanTasksProps } from 'components/Atoms/Cards/CardLoanTasks/CardLoanTasks';
import { Tooltip } from 'react-tooltip'
import Purchase from './Purchase';
import { ModuleKeys } from 'services/task/modules-keys.constanst';

interface Props {
  tasks?: Task[] | any[],
}

const useCardPurchase = ({ tasks }: Props) => {
  const [dataTask, setDataTask] = useState<Task>();
  const [stepNow, setStepNow] = useState<TaskResponse>();
  const [response, setResponse] = useState<TaskResponse>();

  useEffect(() => {
    if (tasks) {
      const data: Task = tasks.find((item) => item.key === ModuleKeys.PURCHASE);
      setDataTask(data);

      const _response = data?.responses.find(item => item.key !== 'doc-another');
      setResponse(_response);

      if (data?.responses.length > 0)
        setStepNow(data?.responses.reduce((max: any, obj) => obj.step > max?.step ? obj : max, _response));
    }
  }, [tasks]);

  const generateCirclesFooter: any = () => {
    const addAnotherDocs = dataTask?.responses?.filter(item => item.key === 'doc-another');
    const docsStates = addAnotherDocs?.map(item => item.state) || []; 
    return [(response?.state || 'DRAFT'), ...docsStates];
  };

  const getTotalApproved = () =>
    dataTask?.responses?.filter((item: any) => item.state !== TaskState.Draft && item.state !== TaskState.RequestError)?.length;

  const tooltipsTexts: any = {
    "APPROVED": 'Approved',
    "REVIEW": 'In Review',
    "REQUEST_ERROR": 'Rejected',
    "DRAFT": 'Not submmitted',
  }

  const tooltipTexts = (state: string) => tooltipsTexts[state];

  const card: CardLoanTasksProps =
  {
    key: ModuleKeys.PURCHASE,
    title: <h4 className="h4">Purchase Agreement</h4>,
    steps: 1,
    stepCurrent: stepNow?.step || 0,
    type: 'quick task',
    state: dataTask?.state,
    actions: dataTask ? [<Purchase key={1} task={dataTask} />] : [],
    text: (
      <p className="body-card">
        Purchase agreement has {' '}
        <span className="body-card-bold-line">
          {!response || response?.files?.length === 0 ? 'not' : ''}
        </span>
        {' '}been uploaded
      </p>
    ),
    text2: (
      <div className='docs-section'>
        <div className='labels'>
          <p className={`body-regular body-regular-bold`}>
            Document status
          </p>
          <p className={`body-card`}>
            {getTotalApproved()}/{generateCirclesFooter()?.length || 0} submitted
          </p>
        </div>
        <div className={`circles-tags`}>
          {generateCirclesFooter().map((state: string, index: number) => {
            let _state = state.toUpperCase() || 'DRAFT';

            return (
              <div key={index}>
                <div
                  data-tooltip-id={`circle-state-${_state}`}
                  data-tooltip-html={`<b>${tooltipTexts(_state)}</b>`}
                  className={`circle circle-${_state}`}
                />
                <Tooltip
                  id={`circle-state-${_state}`}
                  className={`circle-state-tooltip circle-state-tooltip-${_state}`}
                />
              </div>
            )
          })}
        </div>
      </div>
    )
  };

  if(!dataTask) 
    return { card: null };
  
  return {
    card,
    dataTask
  };
};

export default useCardPurchase;